import BstlArtikel from "@/entities/common/bstl_artikel"
import ProdukteLogic from "@/logic/produkte_logic"

export default class ShoppingLogic extends ProdukteLogic {
    get warenkorb() : BstlArtikel[] {
        return this.mainLogic.bestellungPending.artikelliste
    }

    get warenkorbGefuellt() : boolean {
        return this.mainLogic.bestellungPending.artikelliste.length > 0
    }
}
